import { parseTassetUid, Tasset, TassetSchema } from '../../Finance/models/Tasset'
import { getFinder, getInserter, getName } from 'src/util/src/zod'
import { withIdFromName } from '../../Generic/models/Name/withIdFromName'

export const allTassets: Tasset[] = []

export const addTasset = getInserter<Tasset>(getName(TassetSchema), TassetSchema, parseTassetUid, allTassets)

export const findTasset = getFinder(parseTassetUid, allTassets)

export const GST = addTasset(withIdFromName({
  name: 'Green Satoshi Token',
  ticker: 'GST',
  notes: `
    Utility:
    * Upgrade
  `,
}))

export const GMT = addTasset(withIdFromName({
  name: 'Green Metaverse Token',
  ticker: 'GMT',
  notes: `
    Utility:
    * Governance
  `,
}))
